/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EventSchema
 */
export interface EventSchema {
    /**
     * 
     * @type {string}
     * @memberof EventSchema
     */
    name: string;
    /**
     * 
     * @type {any}
     * @memberof EventSchema
     */
    message?: any | null;
    /**
     * 
     * @type {Date}
     * @memberof EventSchema
     */
    created: Date;
    /**
     * 
     * @type {string}
     * @memberof EventSchema
     */
    action?: string;
    /**
     * 
     * @type {string}
     * @memberof EventSchema
     */
    worker?: string;
}

/**
 * Check if a given object implements the EventSchema interface.
 */
export function instanceOfEventSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "created" in value;

    return isInstance;
}

export function EventSchemaFromJSON(json: any): EventSchema {
    return EventSchemaFromJSONTyped(json, false);
}

export function EventSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'created': (new Date(json['created'])),
        'action': !exists(json, 'action') ? undefined : json['action'],
        'worker': !exists(json, 'worker') ? undefined : json['worker'],
    };
}

export function EventSchemaToJSON(value?: EventSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'message': value.message,
        'created': (value.created.toISOString()),
        'action': value.action,
        'worker': value.worker,
    };
}

